import React from 'react';
import { Logo } from './Logo';
export const Footer = () => {
  return <footer className="bg-slate-800" data-id="element-58">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-59">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-60">
          <div className="flex flex-col items-center md:items-start" data-id="element-61">
            <div className="bg-white p-4 rounded-lg inline-block" data-id="element-62">
              <Logo isSmall={true} data-id="element-63" />
            </div>
            <p className="mt-4 text-base text-slate-300 text-center md:text-left" data-id="element-64">
              Cultivating wealth for generations through strategic investment
              management.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-start" data-id="element-65">
            <h3 className="text-sm font-semibold text-slate-300 tracking-wider uppercase" data-id="element-66">
              Navigation
            </h3>
            <div className="mt-4 space-y-2" data-id="element-67">
              <a href="#about" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-68">
                About
              </a>
              <br data-id="element-69" />
              <a href="#services" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-70">
                Services
              </a>
              <br data-id="element-71" />
              <a href="#performance" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-72">
                Performance
              </a>
              <br data-id="element-73" />
              <a href="#team" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-74">
                Team
              </a>
              <br data-id="element-75" />
              <a href="#contact" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-76">
                Contact
              </a>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-start" data-id="element-77">
            <h3 className="text-sm font-semibold text-slate-300 tracking-wider uppercase" data-id="element-78">
              Legal
            </h3>
            <div className="mt-4 space-y-2" data-id="element-79">
              <a href="#" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-80">
                Privacy Policy
              </a>
              <br data-id="element-81" />
              <a href="#" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-82">
                Terms of Service
              </a>
              <br data-id="element-83" />
              <a href="#" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-84">
                Disclaimer
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-slate-700 pt-8" data-id="element-85">
          <p className="text-base text-slate-400 text-center" data-id="element-86">
            © {new Date().getFullYear()} Aurum Grove Capital. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};